import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../Styles/Home.css';
import logo from '../assets/GMF logo no background.png';

const Home = () => {
    const navigate = useNavigate();

    const handleLogInClick = () => {
        navigate('/login');
    };

    return (
        // or should we use class name home-container??
        <div className="Home">
            <header className="header-section">
                <div className="content-container">
                    <img
                        src={logo}
                        alt="Fishbowl Pharmacy Logo"
                        className="logo"
                    />
                    <h1>MD-Sensei</h1>
                    <p>
                        MD-Sensei provides real-time clinical support for
                        healthcare workers in resource limited setting by
                        utilizing an AI-powered Digital Clinical Mentor. Key
                        features of the app include online and offline modes, AI
                        chatbot interaction, Q&A support, user authentication,
                        and data synchronization, all aimed at helping HCWs
                        improve patient outcomes and health, even in challenging
                        environments.
                    </p>

                    <button className="login-button" onClick={handleLogInClick}>
                        Login
                    </button>
                </div>
            </header>
        </div>
    );
};

export default Home;
